/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Note
 */
export interface Note {
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    content: string;
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    readonly createdBy: number;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    readonly createdByName: string;
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    readonly contentType: number;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    readonly contentTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    objectType: string;
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    objectId: number;
    /**
     * 
     * @type {Date}
     * @memberof Note
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Note
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    readonly createdByAvatar: string;
}

/**
 * Check if a given object implements the Note interface.
 */
export function instanceOfNote(value: object): value is Note {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdByName' in value) || value['createdByName'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    if (!('contentTypeName' in value) || value['contentTypeName'] === undefined) return false;
    if (!('objectType' in value) || value['objectType'] === undefined) return false;
    if (!('objectId' in value) || value['objectId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdByAvatar' in value) || value['createdByAvatar'] === undefined) return false;
    return true;
}

export function NoteFromJSON(json: any): Note {
    return NoteFromJSONTyped(json, false);
}

export function NoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Note {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content': json['content'],
        'createdBy': json['created_by'],
        'createdByName': json['created_by_name'],
        'contentType': json['content_type'],
        'contentTypeName': json['content_type_name'],
        'objectType': json['object_type'],
        'objectId': json['object_id'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'createdByAvatar': json['created_by_avatar'],
    };
}

  export function NoteToJSON(json: any): Note {
      return NoteToJSONTyped(json, false);
  }

  export function NoteToJSONTyped(value?: Omit<Note, 'id'|'created_by'|'created_by_name'|'content_type'|'content_type_name'|'created_at'|'updated_at'|'created_by_avatar'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'object_type': value['objectType'],
        'object_id': value['objectId'],
    };
}

